
import InsurenceMainComp from "../../components/insurenace/InsurenceMainComp"

export const InsuranceReportsPages = ({ title_1, title_2, title }) => {
   
    return <div>
        <InsurenceMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}